/**
 * Environment Configuration
 */

import { createConfig, type AppConfig } from '@bloomcode/config';

// Handle SSR - import.meta.env may not be available on server
const env = typeof import.meta !== 'undefined' ? import.meta.env : {};

export const config: AppConfig = createConfig(env);

export const { isProduction, isDevelopment, graphqlEndpoint, loggingEnabled, debugMode } = config;

/**
 * Auth Portal Configuration
 * Uses getAppUrl() for environment-aware URL resolution.
 */
import { getAppUrl } from '@bloomcode/config';

export const authPortalUrl = getAppUrl('portal-auth');

/**
 * Get the auth portal login URL with return URL
 */
export function getAuthPortalLoginUrl(returnUrl?: string): string {
  const url = new URL('/login', authPortalUrl);
  if (returnUrl) {
    url.searchParams.set('returnUrl', returnUrl);
  }
  return url.toString();
}

/**
 * Get the auth portal logout URL with optional return URL
 */
export function getAuthPortalLogoutUrl(returnUrl?: string): string {
  const url = new URL('/logout', authPortalUrl);
  if (returnUrl) {
    url.searchParams.set('returnUrl', returnUrl);
  }
  return url.toString();
}

/**
 * Get the auth portal signup URL with return URL and optional app name
 */
export function getAuthPortalSignupUrl(returnUrl?: string, appName?: string): string {
  const url = new URL('/signup', authPortalUrl);
  if (returnUrl) {
    url.searchParams.set('returnUrl', returnUrl);
  }
  if (appName) {
    url.searchParams.set('app', appName);
  }
  return url.toString();
}
